<template>
  <div class="search-results">
    <ul class="search-results__list">
      <li v-for="(item, i) in list" :key="i" class="search-results__item">
        <a
          @click.prevent="showService(item)"
          class="search-results__item-title"
          href="#"
        >
          {{ item | localeField("name") }}
        </a>
        <BreadCrumbs :links="getServiceBreadcrumbs(item)" />
      </li>
    </ul>
  </div>
</template>

<script>
import { BreadCrumbs } from "@v2/shared/ui/components";

export default {
  name: "ServicesSearchResults",
  components: { BreadCrumbs },
  props: {
    list: Array
  },
  data() {
    return {
      search: null
    };
  },
  methods: {
    showService(service) {
      this.$modal.show("service-modal", { id: service.id });
    },
    getServiceBreadcrumbs(service) {
      let links = [];
      if (service.category) {
        let category = service.category;
        while (category) {
          links.unshift({
            title_rus: category.name_rus,
            title_eng: category.name_eng,
            route: {
              name: "category",
              params: { id: this.$route.params.id, category_id: category.id }
            }
          });
          category = category.parent;
        }
      }
      return links;
    }
  }
};
</script>

<style lang="scss" scoped>
.search-results {
  background: var(--white, #fff);

  &__list {
    list-style: none;
    padding: 10px;
    margin: 0;
  }

  &__item {
    padding: 10px;
    border-radius: 2px;
    transition: background-color var(--transition, 0.2s);

    &:hover {
      background: var(--gray, #f9f9f9);
    }

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    &-title {
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.55;
      display: block;
      margin-bottom: 5px;
      color: var(--dark, #262626);
      text-decoration: none;
      transition: color var(--transition, 0.2s);

      &:hover {
        color: var(--main-dark, #005197);
      }
    }
  }
}
</style>
